import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { RandomUIDGenerator } from "../random/RandomUIDGenerator";
import { SVGEditor } from "../svg/SVGEditor";
import { Inkscape } from "../svg/Inkscape";
import { HTMLEditor } from "../dom-tools/HTMLEditor";
import { SVGKeyFramesBuffer } from "../svg/SVGKeyFramesBuffer";
import { ElementHierarchy } from "../dom-tools/ElementHierarchy";

export class SVGKeyFrames
{
  static attribute = new ElementAttribute( "keyframes" );

  static applyOnDocument()
  {
    SVGKeyFrames.attribute.forEachInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let mainKey =  SVGKeyFrames.attribute.from( e );
    let mainKeyFrame:SVGElement = null;
    let keyFrames:SVGElement[] = [];


    HTMLEditor.forAllChildren( e as HTMLElement, 
      c => 
      { 
        if ( Node.ELEMENT_NODE !== c.nodeType )
        {
          return;
        }

        let s = c as SVGElement;

        if ( ! Inkscape.isInkscapeLayer( s ) )
        {
          return;
        }

        

        let layerName = Inkscape.getLayerName( s );
        
        if ( layerName === mainKey )
        {
          mainKeyFrame = s;
          return;
        }

        keyFrames.push( s );

        
      }
    );


    if ( ! mainKeyFrame )
    {
      console.log( "No main key frame!", e );
      return;
    }

    console.log( "Processing element:", e, mainKeyFrame, keyFrames );

    let hierarchyMain = new ElementHierarchy();
    hierarchyMain.get( mainKeyFrame );
    console.log( "PATHS", mainKeyFrame, hierarchyMain.paths );

    keyFrames.forEach(
      ( kf )=>
      {
        let hierarchy = new ElementHierarchy();
        hierarchy.get( kf );
        console.log( "PATHS", kf, hierarchy.paths );
      }
    )


    let buffer = new SVGKeyFramesBuffer();
    buffer.get( mainKeyFrame, keyFrames );

    keyFrames.forEach(
      ( kf )=>
      {
        kf.style.display = "none"
      }
    )

    buffer.differences.forEach(
      ( value, key )=>
      {
        let element = key;
        let atts = value;

        console.log( "DIFFERENCES FOR:",  element,  "{" + atts.join( "}, {" ) + "}" );
      }
    )  
    
    let currentIndex = 0;

    e.addEventListener( "mousedown", 
     ()=>
     {

      currentIndex = ( currentIndex + 1 ) % ( keyFrames.length + 1 );
      console.log( "currentIndex", currentIndex );

      buffer.differences.forEach(
        ( value, key )=>
        {
          let element = key;
          let atts = value;
  
          atts.forEach(
            ( a )=>
            {
              let attributeValue = a.values[ currentIndex ] || "";
              let svgElement = element as SVGElement;

              if ( SVGEditor.transform === a.attribute )
              {
                svgElement.style.transform = attributeValue;
              }
              else
              {
                a.attribute.to( element, attributeValue );
              }
              
            }
          )
        }
      );  
     }
    )
  }
}